<template>
  <div>
    <p
      class="ota-title text-center mb-10 mt-12 px-10"
      v-text="title"
    />
    <div class="text-center mt-5">
      <OButton
        variant="secondary"
        class="mx-3 mb-3"
        @click="$emit('signup')"
      >
        {{ $t('TwoForOneCampaign.SignUpNow') }}
      </OButton>
      <OButton
        v-if="link"
        :to="link"
        variant="ghost"
        tag="a"
        size="sm"
        class="mx-3"
        @click="$emit('terms')"
      >
        {{ $t('TwoForOneCampaign.Terms') }}
      </OButton>
    </div>
  </div>
</template>

<script>
const OButton = () => import('@/components/OButton')

export default {
  name: 'TwoForOneCampaign',
  components: {
    OButton
  },
  props: {
    link: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
